import React, { Component } from 'react';
import { connect } from 'react-redux';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import {
	DataGrid,
    Column,
    Button,
    SearchPanel,
    FilterRow,
    HeaderFilter,
    ColumnChooser,
	Export,
	Grouping,
	GroupPanel,
	Selection
} from 'devextreme-react/data-grid';

import { ExcelJS , Workbook } from "exceljs";
import saveAs from "file-saver";
import { exportDataGrid as exportDataGridToExcel } from "devextreme/excel_exporter";

import CustomStore from 'devextreme/data/custom_store';
import DeleteIcon from '@material-ui/icons/Delete';
import VisibilityIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import Switch from '@material-ui/core/Switch';

import { getDecisionCategories , setDecisionCategoryStatus , deleteDecisionCategory } from '../../../apis/system/decisions/index';
import { deleteDepartmentCenter } from '../../../apis/departments/centers/deleteDepartmentCenter'
import { triggerDialog, triggerDialogForm, setLoading, triggerNotification  } from '../../../actions';
import { translationHook } from '../../translationHook';
import {
	ButtonDanger,
	ButtonInfo,
	ButtonWarning
} from '../../UI/Buttons';

import DecisionCategoryForm from './decisionCategoriesForm'

class DecisionCategoriesList extends Component {
	constructor(props){
		super(props);
		this.onExporting = this.onExporting.bind(this);
	}
	customizeCellCheckbox = ({data}) => {
        return (
            <Switch
			checked={data.Active_Status_Id}
			name={`centerStatus_${data.Department_Service_Center_Id}`}
			onChange={async () => {
				let at = this.props.currentUser.Data.access_token,
				dataSent = {
					Decision_category_Id: data.Decision_category_Id,
					Active_Status_Id:  data.Active_Status_Id ? 0 : 1
				}

					this.props.setLoading(true, 'dark')

					const response = await setDecisionCategoryStatus(at, dataSent)

					this.props.triggerNotification(true, response)

					this.props.setLoading(false)
			}}
			/>
        )
        
    }

	renderEditForm = (...params) => {
		let viewMood = params[2] === 'view' ? true : false,
			editMood = params[2] === 'edit' ? true : false

        return <DecisionCategoryForm decisionCatId={params[0]} initValues={params[1]} editMood={editMood} viewMood={viewMood} />
    }


	handleDelete = (data) => {
		let at = this.props.currentUser.Data.access_token,
			decisionCatId = data.Decision_category_Id,
			decisionCatName =
				this.props.i18n.language === 'ar'
					? data.Decision_category_Name_AR
					: data.Decision_category_Name_EN,
			dialogTitle = `${this.props.t('confirmDeleteTitle')} ${decisionCatName}`,
			dialogMsg = this.props.t('confirmDeleteMsg');

		this.props.triggerDialog(true, {
			title: dialogTitle,
			message: dialogMsg,
			action: {
				action: deleteDecisionCategory,
				params: [
					at,
					decisionCatId
				],
				text: this.props.t('delete'),
			},
		});
	}

	handleEdit = (data, viewMood) => {

        let decisionCatId = data.Decision_category_Id,
        decisionCatName = this.props.i18n.language === 'ar' ? data.Decision_category_Name_AR : data.Decision_category_Name_EN,
        dialogTitle = `${viewMood === 'view' ? this.props.t('view') : this.props.t('edit')} ${decisionCatName}`

		
        this.props.triggerDialogForm(true, {
            title: dialogTitle,
            renderForm: this.renderEditForm,
            params: [
                decisionCatId,
                data,
				viewMood
            ]
        })

    }

	render() {
		let columnAlign = 'left',
			at = this.props.currentUser.Data.access_token;

		if (this.props.i18n.language === 'ar') {
			columnAlign = 'right'
		}

		const jsonDataSource = new CustomStore({
			key: 'Decision_category_Id',
			load: () => {
				return getDecisionCategories(at);
			},
		});

		return (
			<>
				<DecisionCategoryForm />
                
				<DataGrid
					className={[this.props.i18n.language === 'ar' ? 'dx-grid-ar' : 'dx-grid-en' , 'globalBox'].join(' ')}
					id="dataGrid"
					width={'100%'}
					dataSource={jsonDataSource}
					showBorders={false}
					showColumnLines= {false}
					showRowLines= {true}
					allowColumnResizing={true}
					columnResizingMode={'widget'}
					allowColumnReordering={true}
					rowAlternationEnabled={false}
					focusedRowEnabled={true}
					onExporting={this.onExporting}
					columnWidth={'auto'}
					wordWrapEnabled={true}
					rtlEnabled = {this.props.i18n.language === 'ar' ? true : false}
				>

					<ColumnChooser enabled={true} allowSearch={true} search={'fff'}
						title={this.props.t('dxColumnChooserTitle')}
						emptyPanelText={this.props.t('dxColumnChooserPanelText')}
					/>
					
					<SearchPanel 
						visible={true}
						width={240}
						placeholder={this.props.t('search')}
					/>

					<FilterRow visible={true} />

					<HeaderFilter visible={true} />

					<Export enabled={true} allowExportSelectedData={true}/>

					<Grouping contextMenuEnabled={true} expandMode="rowClick"/>
                	<GroupPanel visible={true} emptyPanelText={this.props.t('dxGroupPanelText')}/>

					<Selection
						mode="multiple"
						selectAllMode={'allPages'}
						showCheckBoxesMode={'always'}
					/>

					<Column
					dataField="Decision_category_Id"
					caption={this.props.t('decisionCategoryID')}
					alignment={'center'}
					>
					</Column>
					
					<Column
					dataField={'Decision_category_Name_AR'}
					caption={this.props.t('decisionCategoryNameAR')}
					alignment={columnAlign}
					>
					</Column>
					<Column cssClass="outlinedColumn"
					dataField={'Decision_category_Name_EN'}
					caption={this.props.t('decisionCategoryNameEN')}
					alignment={'center'}
					>
					</Column>
					
					<Column
					dataField='Active_Status_Id'
					caption={this.props.t('serviceStatus')}
					allowFiltering={false}
					width={'120px'}
					alignment={'center'}
					cellRender={this.customizeCellCheckbox}
					>
					</Column>
				
					<Column cssClass="outlinedColumn nowrapColumn"
						type='buttons'
						caption={this.props.t('details')}
						fixed={true}
						fixedPosition={this.props.i18n.language === 'ar' ? 'left' : 'right'}
					>
						<Button
							render={(record) => {
								return (
									<ButtonWarning
									variant='circleIcon'
									startIcon={<EditIcon />}
									onClick={() => {
                                        this.handleEdit(record.data, 'edit')
                                    }}
									>
									</ButtonWarning>
								);
							}}
						/>

						<Button
							render={(record) => {
								return (
									<ButtonInfo
									variant='circleIcon'
									startIcon={<VisibilityIcon />}
									onClick={() => {
                                        this.handleEdit(record.data, 'view')
                                    }}
									>
										{/* {this.props.t('view')} */}
									</ButtonInfo>
								);
							}}
						/>


						<Button
							render={(record) => {
								return (
									<ButtonDanger
										variant='circleIcon'
										startIcon={<DeleteIcon />}
										onClick={() => this.handleDelete(record.data)}>
										{/* {this.props.t('delete')} */}
									</ButtonDanger>
								);
							}}
						/>
					</Column>
				</DataGrid>
			</>
		);
	}
	
	onExporting(e) {
		let sheetTitle = this.props.t('manageCenters')
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('Main sheet');
        exportDataGridToExcel({
            component: e.component,
            worksheet: worksheet,
			autoFilterEnabled: true,
			topLeftCell: { row: 2, column: 2 },
			topRightCell: { row: 2, column: 2 },
            customizeCell: ({gridCell, excelCell}) => {
                // excelCell.value = gridCell.value;
                excelCell.font = { family: 2, name: 'Cairo', size: 10, color: {argb: "151713"} };
				excelCell.alignment = { indent: 1, wrapText: true, vertical: 'middle' };
				if(gridCell.rowType === 'group') {
					excelCell.fill = {
						type: 'pattern',
						pattern:'solid',
						fgColor:{argb:'d0b166'}
					  };
					excelCell.alignment = { indent: 2 };
					excelCell.font = { family: 2, name: 'Cairo', size: 10, color: {argb: "ffffff"}, bold: true };
				}
				if(gridCell.rowType === 'header') {
				excelCell.fill = {
					type: 'pattern',
					pattern:'solid',
					fgColor:{argb:'58743a'}
					};
				excelCell.alignment = { vertical: 'middle', horizontal: 'center' };
				excelCell.font = { family: 2, name: 'Cairo', size: 12, color: {argb: "ffffff"}, bold: true };
				}
            } 
        }).then(function() {
            workbook.xlsx.writeBuffer()
                .then(function(buffer) {
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${sheetTitle}.xlsx`);
                });
        });
        e.cancel = true;
    }
}

const mapStateToProps = (state) => {
	return {
		currentUser: state.currentUser,
		reload: state.reload,
	};
};

export default connect(mapStateToProps, { triggerDialog, triggerDialogForm, triggerNotification, setLoading })(
	translationHook(DecisionCategoriesList)
);
